import { createReducer, on, Action } from '@ngrx/store';
import * as LoginActions from './login.action';
import { LoginType } from 'src/app/helper/constants';

export interface ILogin {
  loginType: string;
  loginStatus: boolean;
}
export const initialState: ILogin = {
  loginType: LoginType.No_User,
  loginStatus: false
};

const reducer = createReducer(initialState,
  on(LoginActions.SetLoginTypeAction, (state, { loginType }) => ({ ...state, loginType })),
  on(LoginActions.SetLoginStatusAction, (state, { loginStatus }) => ({ ...state, loginStatus })),
);

export function LoginReducer(state: ILogin | undefined, action: Action) {
  return reducer(state, action);
}
